 
//Responsive Stepper
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
 
const StepperHeader = ({
  steps = [],
  activeStep = 0,
  maxWidth = 1000,
  pillHeight = 12,
  pillMinWidth = 40,
  pillMaxWidth = 98,
  activeColor = "#1890ff",
  completedColor = "#40a9ff",
  pendingColor = "#d1d1d1",
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
 
  return (
    <Box
      position="sticky"
      top={0}
      zIndex={10}
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
        bgcolor: "white",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        width: "100%",
        maxWidth,
        mx: "auto",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        flexWrap={{ xs: "wrap", sm: "nowrap" }}
        rowGap={2}
      >
        {/* Left side: Now + Stepper */}
        <Box flex={1} minWidth={0}>
          <Typography
            variant="body1"
            mb={1}
            fontSize={{ xs: 13.5, sm: 14.5 }}
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
          >
            <strong>Now:</strong> {steps[activeStep]}{" "}
            <strong>(In Progress)</strong>
          </Typography>
 
          {/* Pill Progress Bar */}
          <Box display="flex" gap={1.5} mt={2} flexWrap="wrap">
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  flexGrow: 1,
                  minWidth: pillMinWidth,
                  maxWidth: pillMaxWidth,
                  height: pillHeight,
                  borderRadius: 8,
                  bgcolor:
                    index === activeStep
                      ? activeColor
                      : index < activeStep
                      ? completedColor
                      : pendingColor,
                  transition: "all 0.3s",
                }}
              />
            ))}
          </Box>
        </Box>
 
        {/* Right side: Next + Step Count */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "flex-start", sm: "flex-end" },
            textAlign: { xs: "left", sm: "right" },
            flexShrink: 0,
            mt: { xs: 2, sm: 0 },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <Typography
            variant="body1"
            mb={1}
            sx={{ whiteSpace: "nowrap", fontSize: { xs: 13.5, sm: 14.5 } }}
          >
            <Box component="span" fontWeight="fontWeightBold">
              Next:
            </Box>{" "}
            {activeStep < steps.length - 1
              ? steps[activeStep + 1]
              : "Completed"}
          </Typography>
 
          <Typography
            variant="body2"
            color="primary"
            sx={{ fontSize: { xs: 13.5, sm: 15 }, mt: 0.5 }}
          >
            Step {activeStep + 1}/{steps.length}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
 
export default StepperHeader;
 


// import { Box, Typography } from "@mui/material";

// const StepperHeader = ({
//   steps = [],
//   activeStep = 0,
//   containerWidth,
//   maxWidth = 1000,
//   pillWidth = 98,
//   pillHeight = 12,
//   activeColor = "#1890ff",
//   completedColor = "#40a9ff",
//   pendingColor = "#d1d1d1",
// }) => {
//   return (
//     <Box
//       position="sticky"
//       top={0}
//       zIndex={10}
//       sx={{
//         p: 2,
//         borderRadius: 2,
//         bgcolor: "white",
//         boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//         width: containerWidth,
//         maxWidth: maxWidth,
//         margin: "0 auto",
//       }}
//     >
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="flex-start"
//       >
//         {/* Left side: Now + Stepper */}
//         <Box>
//           <Typography variant="body1" mb={1} fontSize={14.5}>
//             <strong>Now:</strong> {steps[activeStep]}{" "}
//             <strong>(In Progress)</strong>
//           </Typography>

//           {/* Pill Progress Bar */}
//           <Box display="flex" gap={2} mt={2}>
//             {steps.map((_, index) => (
//               <Box
//                 key={index}
//                 sx={{
//                   width: pillWidth,
//                   height: pillHeight,
//                   borderRadius: 8,
//                   bgcolor:
//                     index === activeStep
//                       ? activeColor
//                       : index < activeStep
//                       ? completedColor
//                       : pendingColor,
//                   transition: "all 0.3s",
//                 }}
//               />
//             ))}
//           </Box>
//         </Box>

//         {/* Right side: Next + Step Count */}
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "flex-end",
//             minWidth: 0, // allows shrinking
//             maxWidth: "100%", // prevents overflow
//             flexGrow: 1, // allows shifting left if needed
//           }}
//         >
//           <Typography
//             variant="body1"
//             mb={1}
//             sx={{
//               whiteSpace: "nowrap",
//             }}
//           >
//             <Box component="span" fontWeight="fontWeightBold">
//               Next:
//             </Box>{" "}
//             {activeStep < steps.length - 1
//               ? steps[activeStep + 1]
//               : "Completed"}
//           </Typography>

//           <Typography
//             variant="body2"
//             color="primary"
//             sx={{ fontSize: 15, mt: 0.5 }}
//           >
//             Step {activeStep + 1}/{steps.length}
//           </Typography>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default StepperHeader;
